import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hideTranslation',
  standalone: true
})
export class HideTranslationPipe implements PipeTransform {
  transform(value: string, args?: any): any {
    if (value && value.startsWith('-notshown-')) {
      return '';
    }
    return value;
  }
}
